export const fmContent = {
  nav: {
    logo: "Local Farmers Market",
    links: [
      { href: "#services", label: "Services" },
      { href: "#about", label: "About Us" },
      { href: "#results", label: "Client Results" },
    ],
    cta: "Work With Us",
  },
  hero: {
    title: "The Largest Locally-Owned Farmers Market on the East Coast",
    body: "Fresh produce, artisan goods, and a lively community—every week, all year. Come meet your neighbors and taste the difference.",
    cta: "View Schedule",
    badge: "Join the Local Market",
  },
  ribbon: "Owned & operated by a committee of local farmers & small business owners",
  mission: [
    {
      title: "Who We Are",
      body: "We’re a neighborhood cooperative of growers, bakers, makers, and families. Our goal is simple: keep food local and communities thriving.",
    },
    {
      title: "Our Mission",
      body: "We support sustainable agriculture, fair pricing, and inclusive access—creating a vibrant space for small businesses to grow.",
    },
  ],
  support: {
    heading: "Ways to Support Us",
    cards: [
      {
        title: "Become a Volunteer",
        bullets: ["Flexible hours", "Family-friendly"],
      },
      {
        title: "Host/Sponsor an Event",
        bullets: ["Private events", "Indoor/outdoor"],
      },
      {
        title: "Shop the Market",
        bullets: ["Free to attend", "Every week"],
      },
      {
        title: "Become a Vendor",
        bullets: ["Small fee", "2-month commitment"],
      },
    ],
  },
  schedule: {
    title: "Market Schedule",
    items: [
      "Saturdays — 8:00 AM to 2:00 PM",
      "Wednesdays — 4:00 PM to 7:00 PM",
      "Monthly Night Market — First Friday 6:00 PM to 10:00 PM",
    ],
  },
  footer: {
    address: "123 Harvest Lane, Hometown, USA",
    socials: [
      { href: "#", label: "Instagram" },
      { href: "#", label: "Facebook" },
      { href: "#", label: "Email" },
    ],
    small: "© Local Farmers Market. All rights reserved.",
  },
} as const;
